export default "__VITE_ASSET__e4e83cbc__"